import { defineStore } from "pinia";

interface Notification {
  id: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
  timeout?: number;
}

interface NotificationState {
  notifications: Notification[];
}

export const useNotificationStore = defineStore("notifications", {
  state: (): NotificationState => ({
    notifications: [],
  }),

  actions: {
    showNotification(
      message: string,
      type: Notification["type"] = "info",
      timeout = 5000,
    ) {
      const id = Date.now().toString();

      this.notifications.push({
        id,
        message,
        type,
        timeout,
      });

      if (timeout > 0) {
        setTimeout(() => {
          this.removeNotification(id);
        }, timeout);
      }
    },

    showWarning(message: string, timeout = 5000) {
      this.showNotification(message, "warning", timeout);
    },

    showError(message: string, timeout = 5000) {
      this.showNotification(message, "error", timeout);
    },

    removeNotification(id: string) {
      const index = this.notifications.findIndex((n) => n.id === id);
      if (index > -1) {
        this.notifications.splice(index, 1);
      }
    },
  },
});
